<template>
    <div>
        <el-table :data="data.items" empty-text="無資料" size="small" class="salary-edit-table">
            <el-table-column prop="type" label="類型" width="200">
                <template slot-scope="scope">
                    <div class="row-title">
                        <span>{{ scope.row.type }}</span>
                        <ah-tip v-if="scope.row.tip != ''">{{ scope.row.tip }}</ah-tip>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="amt" label="金額" min-width="150">
                <template slot-scope="scope">
                    <el-form-item>
                        <money-input :precision="0" v-model="scope.row.amt" :disabled="scope.$index == 4" @change="updateAmts(scope.row)" style="width: 100%" @focus="handleAmtFocus" />
                    </el-form-item>
                </template>
            </el-table-column>
            <el-table-column prop="date" label="付款日期" width="175">
                <template slot-scope="scope">
                    <el-form-item v-if="scope.$index != 0 && scope.$index != 1" :prop="'forms[2].items[' + scope.$index + '].paY_DAT'" :rules="rules.paY_DAT">
                        <el-date-picker
                            v-model="scope.row.paY_DAT"
                            type="date"
                            value-format="timestamp"
                            placeholder="選擇日期"
                            style="max-width: 150px"
                            :disabled="scope.row.amt == 0 || scope.row.amt == null"
                        >
                        </el-date-picker>
                        <div class="input-under-hint" v-if="scope.$index === 2 || scope.$index === 3">代扣的繳款日期</div>
                    </el-form-item>
                </template>
            </el-table-column>
            <el-table-column prop="bank" label="付款帳戶" width="285">
                <template slot-scope="scope">
                    <el-form-item v-if="scope.$index != 0 && scope.$index != 1" :prop="'forms[2].items[' + scope.$index + '].bnK_SNO'" :rules="rules.bnK_SNO">
                        <ah-el-select-bank-account v-model="scope.row.bnK_SNO" document-type="salary" cny="TWD" :disabled="scope.row.amt == 0 || scope.row.amt == null" hide-borrower allow-cash>
                        </ah-el-select-bank-account>
                    </el-form-item>
                </template>
            </el-table-column>
            <el-table-column prop="fee" label="銀行匯費" width="130">
                <template slot-scope="scope">
                    <el-form-item v-if="scope.$index == 6">
                        <money-input :precision="0" v-model="scope.row.fee" placeholder="匯費" />
                    </el-form-item>
                </template>
            </el-table-column>
        </el-table>
        <el-form-item label-width="210px" class="headcount" prop="forms[2].headcount" :rules="rules.headcount">
            <template slot="label">
                <span class="input-label">人數</span>
            </template>
            <el-input :value="data.headcount" type="number" style="width: 200px" @input="(val) => onInput(val, 'headcount')" />
        </el-form-item>
        <el-form-item>
            <el-input :value="data.mem" type="textarea" :rows="4" placeholder="備註" style="margin-top: 15px" @input="(val) => onInput(val, 'mem')" :maxlength="200" :show-word-limit="true" />
        </el-form-item>
    </div>
</template>

<script>
import mixins from './mixins';

export default {
    mixins: [mixins],
    data() {
        return {
            name: 'bonusData',
        };
    },
    methods: {
        handleAmtFocus(el) {
            console.log('A');
            // eslint-disable-next-line eqeqeq
            if (el.target.value == 0) el.target.select();
        },
    },
};
</script>
